(function () {
  "use strict";

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function computePercent(success, total) {
    var s = Number(success);
    var t = Number(total);
    if (!t || isNaN(s) || isNaN(t)) return 0;
    return clamp((s / t) * 100, 0, 100);
  }

  function formatPercentFR(value) {
    var v = Math.round(value * 10) / 10;
    return v.toFixed(1).replace(".", ",") + "%";
  }

  function colorFor(pct) {
    if (pct >= 98) return "#0f448f";     // bleu
    if (pct >= 90) return "#1f8f3a";     // vert
    if (pct >= 80) return "#d07a00";     // orange
    return "#c62828";                   // rouge
  }

  function initKpis(root) {
    var scope = root || document;
    var kpis = scope.querySelectorAll(".container-caces .caces-kpi");
    kpis.forEach(function (kpi) {
      var success = kpi.getAttribute("data-success");
      var total = kpi.getAttribute("data-total");
      var pct = computePercent(success, total);

      var pctEl = kpi.querySelector(".caces-percentage");
      var bar = kpi.querySelector(".caces-progress-bar");

      if (pctEl) pctEl.textContent = formatPercentFR(pct);
      if (bar) {
        bar.dataset.target = String(pct);
        bar.dataset.color = colorFor(pct);
      }
    });
  }

  // Anime toutes les barres d’un scope (header ou content)
  function animateBars(scope) {
    var root = scope || document;
    var bars = root.querySelectorAll(".container-caces .caces-progress-bar");
    bars.forEach(function (bar) {
      var target = Number(bar.dataset.target || "0");
      var color = bar.dataset.color || "#0f448f";

      // applique la couleur
      bar.style.backgroundColor = color;

      // reset + animate
      bar.style.width = "0%";
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.style.width = target.toFixed(1) + "%";
        });
      });
    });
  }

  // Anime uniquement les barres visibles au chargement (headers)
  function animateVisibleOnLoad() {
    // on anime les barres dans les headers (toujours visibles)
    document.querySelectorAll(".container-caces .accordion-item-header").forEach(function (header) {
      animateBars(header);
    });
  }

  function boot(root) {
    initKpis(root || document);
    animateVisibleOnLoad();
  }

  // Accordéon robuste (Shopify) : toggle .open sur .accordion-item
  document.addEventListener("click", function (e) {
    var header = e.target.closest(".container-caces .accordion-item-header");
    if (!header) return;
    if (header.classList.contains("no-toggle")) return;

    var item = header.closest(".accordion-item");
    if (!item) return;

    // Si tu veux "un seul ouvert à la fois", laisse ce bloc.
    // Sinon, supprime-le.
    document.querySelectorAll(".container-caces .accordion-item.open").forEach(function (it) {
      if (it !== item) it.classList.remove("open");
    });

    var willOpen = !item.classList.contains("open");
    item.classList.toggle("open", willOpen);

    // anime la barre du header à chaque clic (petit feedback)
    animateBars(header);

    // si on ouvre, on anime les barres des sous-catégories visibles
    if (willOpen) {
      var content = item.querySelector(".accordion-item-content");
      if (content) animateBars(content);
    }
  });

  // Init normal
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }

  // Shopify theme editor / sections reloaded
  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();